import * as types from '../constants/ActionTypes';

export const agregarPersona = persona => dispatch => {
  // console.log("Persona en el action: ");
  // console.log(persona)
  dispatch({
    type: types.AGREGAR_PERSONA,
    payload: {
      persona,
    },
  });
};

export const agregarPersonas = personas => dispatch => {
  // console.log("Persona en el reducer: ");
  // console.log(personas)
  dispatch({
    type: types.SET_PERSONAS,
    payload: {
      personas,
    },
  });
};

export const sacarPersona = _id => dispatch => {
  dispatch({
    type: types.ELIMINAR_PERSONA,
    payload: {
      _id,
    },
  });
};

// eslint-disable-next-line no-unused-vars
export const getPersonas = persona => dispatch => {
  dispatch({
    type: types.GET_PERSONAS,
  });
};

export const setPersonas = personas => dispatch => {
  dispatch({
    type: types.SET_PERSONAS,
    payload: {
      personas,
    },
  });
};

export const cambiarRol = (idPersona, rol) => dispatch => {
  dispatch({
    type: types.CAMBIAR_ROL,
    payload: {
      idPersona,
      rol,
    },
  });
};

export const cambiarRolPorIndice = (idPersona, rol, index) => dispatch => {
  dispatch({
    type: types.CAMBIAR_ROL_POR_INDICE,
    payload: {
      idPersona,
      rol,
      index,
    },
  });
};
